<template lang="pug">
  div
    holder(ref='holder',:parent-container='parentContainer',
        :render-tools='renderTools',
        :context='context'
        :transform='transform')
      template(#default='{holder,innerContainer,outerContainer}')
        component(:is='SceneComponent',
          :innerContainer='innerContainer',
          :outerContainer='outerContainer',
          :holder='holder',
          :render-tools='renderTools',
          :partutil='partutil',
          :context='context',
          :depth='depth',
          :parent-transform='parentTransform',
          @loaded='doneLoading',
          :transform='transform')

          template(#children='rest')
            children(:children='transform.children',
              :parent-container='rest.parentContainer',
              :depth='depth+1',
              :child-component='rest.childComponent',
              :parent-transform='transform',
              :partutil='partutil',
              :context='context',
              @loaded='doneLoadingChildren',
              v-bind='rest'
              :render-tools='renderTools')
              template(#child="{...rest2}")
                slot(name='holder'
                  v-bind='Object.assign(rest, rest2)',
                  v-bind:allLoaded='allLoaded',
                )

          template(#holder="{...rest}")
            slot(name='holder',
              v-bind='rest',
              v-bind:parentTransform="rest.parentTransform || parentTransform",
              v-bind:allLoaded='allLoaded',
            )
</template>

<script>
import EventEmitter from 'eventemitter3';
import GenericTransform from './GenericTransform.vue';
import Children from './Children.vue';
import Holder from './Holder.vue';
import Sprite from './Sprite.vue';
import Missing from './Missing.vue';
import TiledSprite from './TiledSprite.vue';
import Video from './Video.vue';
import Toy from './Toy.vue';
import GameText from './Text.vue';
import Primitive from './Primitive.vue';
import Camera from './Camera.vue';

export default {
  name:'transform',
  props:{
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      default() {
        return {
          id: 'root'
        }
      }
    },
    parentContainer:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    },
    depth:{
      type:Number,
      default:0
    },
    context:{
      type:Object,
      default() {
        return {};
      }
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  components:{
    Transform: () => import('./Transform.vue'),
    Children,
    Holder
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    if (!component) {
      console.warn('component not found for transform', this.transform.id);
    }

    let SceneComponent;
    if (!component) {
      SceneComponent = Missing;
    } else if (component.type === 'sprite') {
      SceneComponent = Sprite;
    } else if (component.type === 'tiledSprite') {
      SceneComponent = TiledSprite;
    } else if (component.type === 'toy') {
      SceneComponent = Toy;
    } else if (component.type === 'text') {
      SceneComponent = GameText;
    } else if (component.type === 'primitive') {
      SceneComponent = Primitive;
    } else if (component.type === 'camera') {
      SceneComponent = Camera;
    } else if (component.type === 'video') {
      SceneComponent = Video;
    } else {
      SceneComponent = GenericTransform;
    }
    return {
      component,
      loaded:false,
      childrenLoaded:false,
      SceneComponent,
      allLoaded:false
    }
  },
  mounted() {
  },
  beforeCreate() {
  },
  beforeDestroy() {
  },
  methods:{
    doneLoading() {
      this.loaded = true;
      this.checkLoadingState();
      //this.$emit("loaded");
    },
    doneLoadingChildren() {
      this.childrenLoaded = true;
      this.checkLoadingState();
    },
    checkLoadingState() {
      if (this.loaded && (this.transform.children.length === 0 || this.childrenLoaded)) {

        this.$emit("loaded");

        this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          this.allLoaded = true;
          this.renderTools.addToRunBatch( () => {
            this.renderTools.executeReadyEvents(this.transform, this.$refs.holder.holder);
          });
        });
        });
      }
    }
  },
  computed:{
  },
  watch:{
    disabled(nv) {
      if (this.$refs.holder) {
        this.$refs.holder.setDisabled(nv);
      }
    }
  }
}


</script>
<style>
.pbc-controls {
  background-color:white;
}
</style>

